module.exports = __webpack_public_path__ + "img/SolpopLogo.f003e32c.jpg";